import { render, staticRenderFns } from "./historicalOrders.vue?vue&type=template&id=68a71c06&scoped=true&"
import script from "./historicalOrders.vue?vue&type=script&lang=js&"
export * from "./historicalOrders.vue?vue&type=script&lang=js&"
import style0 from "./historicalOrders.vue?vue&type=style&index=0&id=68a71c06&lang=scss&scoped=true&"
import style1 from "./historicalOrders.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a71c06",
  null
  
)

export default component.exports